"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBannerSliderJson = getBannerSliderJson;
exports.getEssentialProductsJson = getEssentialProductsJson;
exports.getHealthConditionsJson = getHealthConditionsJson;
exports.getOffBoxJson = getOffBoxJson;
exports.getPopularJson = getPopularJson;
exports.getShopByBrandsJson = getShopByBrandsJson;
exports.getStaticBannerJson = getStaticBannerJson;
exports.getTopDealsJson = getTopDealsJson;
exports.getTrendingProductsJson = getTrendingProductsJson;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { apiCall } from '../../../common/api/api';

function getBannerSliderJson(apiUrl, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + `${apiUrl}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getPopularJson(apiUrl, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + `${apiUrl}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getTopDealsJson(params, tokenData) {
  const apiUrl = params === null || params === void 0 ? void 0 : params.apiUrl;
  const query = params;
  delete query.apiUrl;
  const querystring = (0, _utils.getQuery)(query);
  const apiEndPoint = _ApiConst.BASE_URL + `${apiUrl}${querystring}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getStaticBannerJson(apiUrl, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + `${apiUrl}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getHealthConditionsJson(apiUrl, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + `${apiUrl}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getEssentialProductsJson(params, tokenData) {
  const apiUrl = params === null || params === void 0 ? void 0 : params.apiUrl;
  const query = params;
  delete query.apiUrl;
  const querystring = (0, _utils.getQuery)(query);
  const apiEndPoint = _ApiConst.BASE_URL + `${apiUrl}${querystring}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getOffBoxJson(apiUrl, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + `${apiUrl}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getTrendingProductsJson(params, tokenData) {
  const apiUrl = params === null || params === void 0 ? void 0 : params.apiUrl;
  const query = params;
  delete query.apiUrl;
  const querystring = (0, _utils.getQuery)(query);
  const apiEndPoint = _ApiConst.BASE_URL + `${apiUrl}${querystring}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getShopByBrandsJson(apiUrl, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + `${apiUrl}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}